import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const userService = {
  users,
  getMembers,
  deleteUser,
  updateUserProfile,
  addMember,
  getMembersNotInProject
}

const API_BASE = apiRoute() + API_V1

function users () {
  return fetchWrapper.get(`${API_BASE}/admin/users/`)
}
function getMembersNotInProject (projectId) {
  return fetchWrapper.get(`${API_BASE}/admin/users/projects/${projectId}/users-not-in-project`)
}
function getMembers (projectId) {
  return fetchWrapper.get(`${API_BASE}/admin/users/${projectId}/members/`)
}

function updateUserProfile (userInfo) {
  return fetchWrapper.put(`${API_BASE}/admin/users/projects/${userInfo._id}`, userInfo)
}

function deleteUser (projectId, userId) {
  return fetchWrapper.delete(
    `${API_BASE}/admin/users/projects/${projectId}/members/${userId}/`
  )
}

function addMember (projectId, membersWithRoles) {
  // // console.log('this is the data of the members', membersWithRoles)
  return fetchWrapper.put(
    `${API_BASE}/training/images/projects/${projectId}/add/members/`,
    {
      members: membersWithRoles // Use the correct property name here
    }
  )
}
